import {
  CustomerServiceOutlined,
  MoneyCollectOutlined,
} from '@ant-design/icons';
import {
  FormFilter,
  Portlet,
  PortletTable,
  SelectSuggest,
  UTILS,
  usePrivilege,
  EnumSelectbox,
} from '@cms/tpl';
import { Button, Card, Col, Form, Input, Row, Statistic, Switch } from 'antd';
import { API_PATHS, CONTAINER, ICONS } from 'common';
import MonthPicker from 'components/monthpicker/MonthPicker';
import ENUMS from 'enums';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OptionService from 'services/OptionService';
import FORMAT from 'utils/Format';
import Service from './Service';
import { PAYMENT_STATUS } from '../../enums/RevenueType';

const ContractRevenueIndex = () => {
  const [form] = Form.useForm();
  const isViewAll = usePrivilege('ViewAll');
  const navigate = useNavigate();
  const [tableMonitor, setTableMonitor] = useState({});
  const [data, setData] = useState({ items: [], total: 0 });
  const [showAll, setShowAll] = useState(false);
  const [total, setTotal] = useState({ listen: 0, revenue: 0 });
  useEffect(() => {
    Service.getTotal(location.search).then((resp) => {
      setTotal({
        listen: resp?.item?.listen || 0,
        revenue: resp?.item?.revenue || 0,
      });
    });
  }, [location.search]);
  return (
    <React.Fragment>
      <Row className='stats-row' gutter={16}>
        <Col span={12}>
          <Card>
            <Statistic
              title={`Tổng doanh thu chia sẻ`}
              value={total.revenue}
              valueStyle={{ color: 'rgb(34, 145, 169)' }}
              prefix={<MoneyCollectOutlined />}
              suffix='VNĐ'
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card>
            <Statistic
              title={`Tổng lượt nghe`}
              value={total.listen}
              valueStyle={{ color: 'rgb(147, 28, 143)' }}
              prefix={<CustomerServiceOutlined />}
              suffix=''
            />
          </Card>
        </Col>
      </Row>
      <Portlet title='Lọc hợp đồng' icon={ICONS.SearchOutlined}>
        <FormFilter
          autoFetch
          name='form-filter'
          form={form}
          items={FILTERS}
          mapURLSearchParams={true}
          setTableMonitor={setTableMonitor}
        />
      </Portlet>
      <PortletTable
        title='Danh sách hợp đồng'
        icon={ICONS.BarsOutlined}
        tableMonitor={tableMonitor}
        onTableMonitor={() => setTableMonitor({})}
        hideSelectedRow
        source={{
          data: data,
          onChangeData: setData,
          endpoint: API_PATHS.CONTRACT_REVENUE.GET.PAG,
          filterByQs: true,
        }}
        columns={showAll ? COLUMNS_ALL : COLUMNS}
        extendedAction={[
          isViewAll && (
            <Switch
              checkedChildren='Xem rút gọn'
              unCheckedChildren='Xem tất cả'
              onChange={setShowAll}
            />
          ),
          <Button
            type='ghost'
            icon={ICONS.UploadOutlined}
            onClick={() => {
              const urlSearchParams = new URLSearchParams(
                window.location.search
              );
              urlSearchParams.append('tab', '1');
              navigate(
                `/${
                  CONTAINER.EXPORT_CONTRACT_REVENUE
                }?${urlSearchParams.toString()}`
              );
            }}
          >
            Xuất dữ liệu
          </Button>,
        ]}
      />
    </React.Fragment>
  );
};

const FILTERS = [
  {
    label: 'Tháng',
    name: 'month',
    input: <MonthPicker />,
  },
  {
    label: 'Số hợp đồng',
    name: 'contractNumber',
    input: <Input />,
  },
  {
    label: 'Đối tác',
    name: 'businessPartnerId',
    input: (
      <SelectSuggest
        allowSearchEmpty
        suggestApi={OptionService.getBusinessPartners}
      />
    ),
  },
  {
    label: 'Thanh toán',
    name: 'paymentStatus',
    input: (
      <EnumSelectbox
        enums={PAYMENT_STATUS}
        defaultValue={PAYMENT_STATUS.PAYMENT[0]}
      />
    ),
  },
];
const COLUMNS = [
  {
    title: 'Tháng',
    dataIndex: 'month',
  },
  {
    title: 'Số hợp đồng',
    dataIndex: 'contractNumber',
  },
  {
    title: 'Đối tác',
    dataIndex: ['businessPartner', 'legalName'],
  },
  {
    title: 'Lượt nghe',
    dataIndex: 'listen',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Doanh thu',
    dataIndex: 'revenue',
    render: (value, entry) =>
      FORMAT.numberWithCommas(
        entry.adsShareRevenue + entry.distributionShareRevenue
      ),
  },
  {
    title: 'Doanh thu cam kết',
    dataIndex: 'committedRevenue',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Doanh thu chia sẻ',
    dataIndex: 'shareRevenue',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'MG còn lại',
    dataIndex: 'calcRemainingDebt',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Tiền tệ',
    dataIndex: '',
    render: () => 'VNĐ',
  },
  {
    title: 'Tình trạng thanh toán',
    dataIndex: 'paymentStatusNames',
  },
  {
    title: 'Loại hợp đồng',
    dataIndex: ['businessPartner', 'type'],
    render: (type) =>
      UTILS.ENUM.findByValue(ENUMS.BusinessPartnerType, type, 1),
  },
];

const COLUMNS_ALL = [
  {
    title: 'Tháng',
    dataIndex: 'month',
  },
  {
    title: 'Số hợp đồng',
    dataIndex: 'contractNumber',
  },
  {
    title: 'Đối tác',
    dataIndex: ['businessPartner', 'legalName'],
  },
  {
    title: 'Lượt nghe QC',
    dataIndex: 'adsListen',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Doanh thu chia sẻ QC',
    dataIndex: 'adsShareRevenue',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Lượt nghe distribution',
    dataIndex: 'distributionListen',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Doanh thu chia sẻ distribution',
    dataIndex: 'distributionShareRevenue',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Lượt nghe',
    dataIndex: 'listen',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Doanh thu',
    dataIndex: 'revenue',
    render: (value, entry) =>
      FORMAT.numberWithCommas(
        entry.adsShareRevenue + entry.distributionShareRevenue
      ),
  },
  {
    title: 'Doanh thu cam kết',
    dataIndex: 'committedRevenue',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Doanh thu chia sẻ',
    dataIndex: 'shareRevenue',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'MG còn lại',
    dataIndex: 'calcRemainingDebt',
    render: (value) => FORMAT.numberWithCommas(value),
  },
  {
    title: 'Tiền tệ',
    dataIndex: '',
    render: () => 'VNĐ',
  },
  {
    title: 'Tình trạng thanh toán',
    dataIndex: 'paymentStatusNames',
  },
  {
    title: 'Loại hợp đồng',
    dataIndex: ['businessPartner', 'type'],
    render: (type) =>
      UTILS.ENUM.findByValue(ENUMS.BusinessPartnerType, type, 1),
  },
];
export default ContractRevenueIndex;
